// 公共导航使用与后端 WebGameCategory 相同的稳定路由；场馆数据独立加载。
export const publicGameCategories = Object.freeze([
  { code: 'SPORTS', navLabel: '体育', tabLabel: '体育赛事', route: '/game/sport', sort: 10 },
  { code: 'LIVE', navLabel: '真人', tabLabel: '真人娱乐', route: '/game/realbet', sort: 20 },
  { code: 'CHESS', navLabel: '棋牌', tabLabel: '棋牌游戏', route: '/game/chess', sort: 30 },
  { code: 'ESPORTS', navLabel: '电竞', tabLabel: '电子竞技', route: '/game/gaming', sort: 40 },
  { code: 'LOTTERY', navLabel: '彩票', tabLabel: '彩票投注', route: '/game/lottery', sort: 50 },
  { code: 'SLOT', navLabel: '电子', tabLabel: '电子游戏', route: '/game/egame', sort: 60 },
  { code: 'ENTERTAINMENT', navLabel: '娱乐', tabLabel: '捕鱼娱乐', route: '/game/fishing', sort: 70 },
])

export function resolveGameCategories(venues = []) {
  const categories = new Map(publicGameCategories.map(category => [category.code, { ...category }]))
  for (const venue of venues) {
    if (!venue.categoryCode || !venue.categoryPath || !venue.navLabel || !venue.tabLabel) continue
    categories.set(venue.categoryCode, {
      code: venue.categoryCode,
      route: venue.categoryPath,
      navLabel: venue.navLabel,
      tabLabel: venue.tabLabel,
      sort: Number(venue.categorySort) || categories.get(venue.categoryCode)?.sort || 100,
    })
  }
  return [...categories.values()].sort((left, right) => left.sort - right.sort)
}

export const memberNavigation = Object.freeze([
  { label: '个人资料', path: '/member', icon: 'account' },
  { label: 'VIP特权', path: '/mine/vip', icon: 'vip' },
  { label: '福利中心', path: '/mine/record/welfare', icon: 'gift' },
  { label: '余额宝', path: '/member/balance-treasure', icon: 'wallet' },
  { label: '实时返水', path: '/mine/rebate', icon: 'rebate' },
  { label: '我的钱包', path: '/mine/finance/wallet', icon: 'wallet' },
  { label: '交易记录', path: '/mine/record/transRecord', icon: 'record' },
  { label: '投注记录', path: '/mine/record/betRecord', icon: 'record' },
  { label: '兑奖记录', path: '/mine/record/giftRecord', icon: 'gift' },
  { label: '消息中心', path: '/mine/messages', icon: 'message' },
  { label: '意见反馈', path: '/mine/feedback', icon: 'message' },
  { label: '帮助中心', path: '/help/center', icon: 'help' },
])

const memberAliases = {
  '/activity': '/activity/discount',
  '/mine': '/member',
  '/mine/assets': '/mine/finance/wallet',
  '/register': '/user/register',
  '/mine/userInfo': '/member',
  '/mine/balance': '/member/balance-treasure',
  '/mine/balanceTreasure': '/member/balance-treasure',
  '/mine/mail': '/mine/messages',
  '/mine/message': '/mine/messages',
}
export const normalizeSitePath = path => memberAliases[path] || path
// 旧认证地址仅作为弹框入口，不再渲染独立页面。
export const authModeForPath = path => ({ '/user/login': 'login', '/login': 'login', '/user/register': 'register' }[normalizeSitePath(path)] || '')
export const isMemberPath = path => path === '/member' || path.startsWith('/member/') || path.startsWith('/mine/')

export function safeExternalUrl(value) {
  try {
    const url = new URL(value)
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : ''
  } catch { return '' }
}
